import React, { Component } from "react";
import { utils } from '../../helpers';
import { withTranslation } from 'react-i18next';
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Input
} from "reactstrap";
import Select from "react-select";
import moment from 'moment';
import Datetime from "react-datetime";
import DiscreteValues from "../../constants/slider.constants";
import Nouislider from "react-nouislider";
import DailyChart from "./DailyChart";
import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
import ErrorModal from "../Components/ErrorModal"
import SweetAlert from "react-bootstrap-sweetalert";
import ReactTable from "react-table";
import { loopbackService } from '../../services';

import { roleConstants } from '../../constants';
import User from '../../entities/User';

class DailyProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      alert: null,
      isEditingProfile: props.isEditingProfile,
      editingProfile: props.editingProfile,
      saving: false,
      validationError: null
    };

    const { t } = props;
    this.transitionModeOptions = [
      { label: t("Alba"), value: "sunrise" },
      { label: t("Tramonto"), value: "sunset" },
      // { label: t("Mezzanotte"), value: "midnight" },
      { label: t("Assoluto"), value: "absolute" }
    ];
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps)
  }


  render() {

    let { selectedProfile, t, handleCancelProfile } = this.props;
    let { isEditingProfile, editingProfile, errors, saving } = this.state;

    const user = User.current();
    const isGuest = (user.userRoleId == roleConstants.GUEST);

    let label = isEditingProfile ? editingProfile !== null ? editingProfile.label : "" : selectedProfile !== null ? selectedProfile.label : "";
    return (
      <Card className="center">

        <CardHeader className="main-wrapper">
          <CardTitle>

            {errors && errors.length > 0 && <ErrorModal error={errors} onClickHandler={() => { this.setState({ errors: [] }) }} />}
            <div className="form-name">
              <Input
                name="label"
                type="text"
                value={label}
                disabled={!isEditingProfile}
                onChange={(e) => {
                  const { name, value } = e.target;
                  editingProfile[name] = value;
                  this.setState({ editingProfile });
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    this.saveProfile();
                  }
                }}
              />


              <div className="form-actions">

                {!isEditingProfile &&
                  <ButtonWithTooltip
                    id="profile_edit"
                    color="warning"
                    tooltipText={t("Modifica")}
                    size="sm"
                    disabled={isGuest}
                    onClick={() => {
                      this.setState({
                        isEditingProfile: true,
                        editingProfile: JSON.parse(JSON.stringify(selectedProfile))
                      })
                    }}
                  ><i className="fa fa-edit" />
                  </ButtonWithTooltip>
                }
                {!isEditingProfile &&
                  <ButtonWithTooltip
                    id="profile_delete"
                    color="danger"
                    size="sm"
                    tooltipText={t("Elimina")}
                    disabled={isGuest}
                    onClick={() => { this.confirmDeleteProfile(); }}
                  >
                    <i className="fa fa-trash" />
                  </ButtonWithTooltip>
                }

                {isEditingProfile &&
                  <ButtonWithTooltip
                    id="profile_save"
                    color="success"
                    size="sm"
                    disabled={saving}
                    tooltipText={t("Salva")}
                    onClick={() => {
                      this.saveProfile();
                    }}
                  >
                    {!saving && <i className="fa fa-check" />}
                    {saving && <i style={{ position: 'unset' }} className="fa fa-refresh fa-spin" />}
                  </ButtonWithTooltip>
                }
                {isEditingProfile &&
                  <ButtonWithTooltip
                    id="profile_cancel"
                    color="default"
                    size="sm"
                    tooltipText={t("Annulla")}
                    onClick={() => {
                      handleCancelProfile();
                      //this.setState({ editingProfile: null, isEditingProfile: false })
                    }}
                  >
                    <i className="fa fa-times" />
                  </ButtonWithTooltip>
                }

              </div>
            </div>
          </CardTitle>
        </CardHeader>
        <CardBody className="full-height-map no-padding">
          {this.state.alert}
          {this.renderTransitions()}
        </CardBody>
      </Card>
    );
  }


  /**
   */
  renderTransitions() {

    const { t, selectedProfile, legacyTimer } = this.props;

    const { editingProfile, isEditingProfile, validationError } = this.state;

    let transitions = [];

    if (editingProfile === null && selectedProfile === null)
      return null;

    // Controllo se valorizzato il parametro dailyTransitions
    let profile = isEditingProfile ? editingProfile : selectedProfile;
    if (profile['dailyTransitions'] == undefined) {
      for (let i = 1; i <= 5; i++) {
        let key = 'transition' + i;
        let transition = profile[key];
        transitions.push(transition);
      }
    }
    else {
      // Nuova gestione profili timer
      for (let trans of profile['dailyTransitions']) {
        /*if(trans.type=='plantOnOff') {
          if (trans.outValue == 104) {
            trans.outValue = 100;
          }
          if (trans.outValue == 102) {
            trans.outValue = 0;
          }
        }*/
        transitions.push(trans);
      }
    }

    // Render valore outValue
    const renderOutValue = (val) => {
      switch (val) {
        case null: return t("SPENTO");
        case 0: return t("SPENTO");
        case -10: return t("IMPIANTO SPENTO");
        case 110: return t("IMPIANTO ACCESO");
        case 126: return t("DISABILITATA");
        default: return val + "%";
      }
    }

    return (
      <div className="details-wrapper">

        <div style={{ width: "100%", height: "200px" }} >
          <DailyChart
            transitions={transitions}
          />
        </div>

        <Card className="card-transitions">

          <CardHeader className="config-card-header">
            <CardTitle className="config-card-title" >
              <span style={{ flex: 1 }}>{t("Transizioni")}</span>
            </CardTitle>
          </CardHeader>

          <CardBody>

            <ReactTable
              data={transitions}
              className="-striped -highlight configurations"
              pageSize={transitions && transitions.length}
              showPagination={false}

              NoDataComponent={() => null}
              columns={[
                {
                  Header: "",
                  accessor: "",
                  filterable: false,
                  sortable: false,
                  width: 30,
                  Cell: (row) => {
                    let disabledFlag = "disabled";
                    if (isEditingProfile && legacyTimer===false) {
                      disabledFlag = "";
                    }
                    return (
                      <div className="no-overflow" align="">
                        <input
                          type="checkbox"
                          checked={(row.value && row.value.enable === true) ? "checked" : ""}
                          disabled={disabledFlag}
                          onChange={option => {
                            let profile = undefined;
                            if (option && option.target !== null) {
                              if (legacyTimer === true) {
                                let key = 'transition' + (row.index + 1);
                                profile = editingProfile[key];
                              } else {
                                profile = editingProfile.dailyTransitions[row.index];
                              }
                              profile.enable = option.target.checked;
                              this.setState({ editingProfile });
                            }
                          }}
                        />
                      </div>
                    )
                  }
                },
                {
                  Header: "#",
                  accessor: "",
                  filterable: false,
                  sortable: false,
                  width: 30,
                  Cell: (row) => {
                    return (<div className="no-overflow" align="">{row.index + 1}</div>)
                  }
                },
                {
                  Header: t("Modo"),
                  accessor: "mode",
                  filterable: false,
                  sortable: false,
                  minWidth: 100,
                  maxWidth: 150,
                  Cell: (row) => {

                    const selectedOption = utils.getSelectedOption(this.transitionModeOptions, row.value);

                    if (isEditingProfile) {
                      return (
                        <Select
                          closeOnSelect={true}
                          placeholder={t("Modo")}
                          name="mode"
                          clearable={false}
                          value={selectedOption}
                          options={this.transitionModeOptions}
                          disabled={(editingProfile.dailyTransitions && editingProfile.dailyTransitions.length>0 && editingProfile.dailyTransitions[row.index].enable === false) ? true : false}
                          onChange={option => {
                            let profile = undefined;
                            if (option && option.value !== null) {
                              if (legacyTimer === true) {
                                let key = 'transition' + (row.index + 1);
                                profile = editingProfile[key];
                              } else {
                                profile = editingProfile.dailyTransitions[row.index];
                              }
                              profile.mode = option.value;
                              if (profile.mode === "sunset" || profile.mode === "sunrise" || profile.mode === "absolute") {
                                profile.timer = 0;
                              }
                              this.setState({ editingProfile });
                            }
                          }}
                        />
                      );
                    } else {
                      return (<div className="no-overflow" >{selectedOption && selectedOption.label}</div>);
                    }
                  }
                },
                {
                  Header: t("Time / Offset"),
                  accessor: "timer",
                  filterable: false,
                  sortable: false,
                  minWidth: 80,
                  maxWidth: 120,
                  Cell: (row) => {

                    let value = "";
                    // let key = "timer_"+row.index+ (validationError && validationError.field == 'timer' ? moment().unix(): "");

                    if (row.original.mode === 'absolute') {

                      let raw = row.value ? parseFloat(row.value) : 0;
                      let hours = ("" + Math.floor(raw / 60)).padStart(2, "0");
                      let mins = ("" + (raw % 60)).padStart(2, "0");

                      value = hours + ":" + mins;

                      if (isEditingProfile) {
                        return (
                          <React.Fragment>
                            <Datetime
                              // key = { key }
                              dateFormat={false}
                              timeFormat={"HH:mm"}
                              value={value}
                              inputProps={{
                                disabled: ((editingProfile.dailyTransitions && editingProfile.dailyTransitions.length>0 && editingProfile.dailyTransitions[row.index].enable === false) ? true : false)
                              }}
                              onChange={(time) => {
                                this.assignTime(row, time);
                              }}
                              onBlur={(time) => {
                                if (!this.assignTime(row, time)) {
                                  if(legacyTimer===true) {
                                    let key = "transition" + (row.index + 1);
                                    editingProfile[key].timer = null;  
                                  }
                                  else {
                                    editingProfile.dailyTransitions[row.index].timer = null;
                                  }
                                  this.setState({ editingProfile });
                                }
                              }}
                            />
                            {validationError && validationError.field == 'timer' &&
                              <span className="validationError">{validationError.error}</span>
                            }
                          </React.Fragment>

                        );

                      }

                    } else {

                      value = row.value;

                      if (isEditingProfile) {

                        return (
                          <Input
                            type="number"
                            value={value !== null ? value : ""}
                            disabled={(editingProfile.dailyTransitions && editingProfile.dailyTransitions.length>0 && editingProfile.dailyTransitions[row.index].enable === false) ? true : false}
                            onChange={(e) => {
                              const { name, value } = e.target;
                              
                              if(legacyTimer===true) {
                                let key = "transition" + (row.index + 1);
                                editingProfile[key].timer = parseInt(value);  
                              }
                              else {
                                editingProfile.dailyTransitions[row.index].timer = parseInt(value);
                              }
                              this.setState({ editingProfile })
                            }}
                          />
                        );
                      }
                    }
                    return (<div className="no-overflow" >{value}</div>);

                  }

                },
                {
                  Header: t("Valore"),
                  accessor: "outValue",
                  filterable: false,
                  sortable: false,
                  Cell: (row) => {

                    // Adattamento valori
                    if (row.value == 102) {
                      row.value = -10;
                    }
                    if (row.value == 104) {
                      row.value = 110;
                    }

                    if (isEditingProfile) {
                      return (
                        <div style={{ display: "flex", alignItems: "center", }}>
                          <span style={{ flex: 1, paddingLeft: "15px", paddingRight: "15px" }}>
                            <Nouislider
                              start={[(row.value == null ? 0 : row.value)]}
                              connect={[true, false]}
                              snap={(legacyTimer===true) ? true : false}
                              disabled={(editingProfile.dailyTransitions && editingProfile.dailyTransitions.length>0 && editingProfile.dailyTransitions[row.index].enable === false) ? true : false}
                              step={10}
                              range={(legacyTimer === true) ? DiscreteValues.legacy : DiscreteValues.default}
                              onSlide={(value) => {
                                if (legacyTimer === true) {
                                  let key = "transition" + (row.index + 1);
                                  editingProfile[key].outValue = value[0];
                                  this.setState({ editingProfile })
                                }
                                else {
                                  let val = parseInt(value[0]);
                                  if (val == -10) {
                                    editingProfile.dailyTransitions[row.index].outValue = 102;
                                  }
                                  else if (val == 110) {
                                    editingProfile.dailyTransitions[row.index].outValue = 104;
                                  }
                                  else {
                                    editingProfile.dailyTransitions[row.index].outValue = val;
                                  }
                                  //editingProfile.dailyTransitions[row.index].outValue = parseInt(value[0])
                                  if (editingProfile.dailyTransitions[row.index].outValue == 102 || editingProfile.dailyTransitions[row.index].outValue == 104) {
                                    editingProfile.dailyTransitions[row.index].type = 'plantOnOff';
                                  } else {
                                    editingProfile.dailyTransitions[row.index].type = 'dimmering';
                                  }
                                  this.setState({ editingProfile })
                                }
                              }}
                              onChange={(value) => {
                                if (legacyTimer === true) {
                                  let key = "transition" + (row.index + 1);
                                  editingProfile[key].outValue = parseInt(value[0]);
                                  this.setState({ editingProfile })
                                }
                                else {
                                  let val = parseInt(value[0]);
                                  if (val == -10) {
                                    editingProfile.dailyTransitions[row.index].outValue = 102;
                                  }
                                  else if (val == 110) {
                                    editingProfile.dailyTransitions[row.index].outValue = 104;
                                  }
                                  else {
                                    editingProfile.dailyTransitions[row.index].outValue = val;
                                  }
                                  //editingProfile.dailyTransitions[row.index].outValue = parseInt(value[0])
                                  if (editingProfile.dailyTransitions[row.index].outValue == 102 || editingProfile.dailyTransitions[row.index].outValue == 104) {
                                    editingProfile.dailyTransitions[row.index].type = 'plantOnOff';
                                  }
                                  else {
                                    editingProfile.dailyTransitions[row.index].type = 'dimmering';
                                  }
                                  this.setState({ editingProfile })
                                }
                              }}
                            /></span>
                          <span style={{ flex: 1, textAlign: "center"}}>
                            {
                              //((row.value == null || row.value == 0) ? t("SPENTO") : (row.value == 100 ? t("ACCESO") : parseInt(row.value) + " %"))
                              (row.original.enable && row.original.enable === true) ? renderOutValue(row.value) : renderOutValue(126)
                              //renderOutValue(row.value)
                            }
                          </span>

                        </div>
                      );
                    }
                    else {

                      return (
                        <div style={{ textAlign: "center" }}>
                          {
                            //((row.value == null || row.value == 0) ? t("SPENTO") : (row.value == 100 ? t("ACCESO") : row.value + " %"))
                            //(row.row._original && row.row._original.enable && row.row._original.enable===false) ? renderOutValue(126) : renderOutValue(row.value)
                            (row.original.enable && row.original.enable === true) ? renderOutValue(row.value) : renderOutValue(126)
                            //renderOutValue(row.value)
                          }
                        </div>
                      );

                    }



                  }

                }
              ]}


            />
          </CardBody>
        </Card>


      </div>
    );
  }

  assignTime(row, time) {
    const { t, legacyTimer } = this.props;
    let { editingProfile } = this.state;
    if (time && time instanceof moment) {
      if (!time.isValid()) {
        this.setState({ validationError: { field: 'timer', error: t("Formato orario non valido") } });
        return false;
      }
      let hours = parseInt(time.format("HH"));
      let mins = parseInt(time.format("mm"));
      if(legacyTimer===true) {
        let key = "transition" + (row.index + 1);
        editingProfile[key].timer = hours * 60 + mins;
      }
      else {
        editingProfile.dailyTransitions[row.index].timer = hours * 60 + mins;
      }
      this.setState({ editingProfile, validationError: null })
      return true;
    }
    return false;
  }

  async saveProfile() {

    try {

      let { handleSavedProfile } = this.props;
      let { editingProfile } = this.state;

      this.setState({ saving: true });

      let savedProfile = await loopbackService.edit('plant', 'timerprofiledaily', editingProfile, "PUT");

      handleSavedProfile(savedProfile);

      this.setState({
        isEditingProfile: false,
        editingProfile: null,
        saving: false
      });


    } catch (error) {
      this.setState({ errors: [error], saving: false });
    }
  }


  confirmDeleteProfile() {

    const { t } = this.props;
    const { model, selectedProfile } = this.state;

    if (!selectedProfile) {
      return;
    }

    this.setState({
      alert: (
        <SweetAlert
          warning
          customClass="custom-sweet-alert"
          style={{ display: "block" }}
          title={t("Elimina") + " " + selectedProfile.label}
          onConfirm={() => {
            this.deleteProfile();
            this.setState({
              alert: null
            });

          }}
          onCancel={() => {
            this.setState({
              alert: null
            });
          }}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText={t("SI")}
          cancelBtnText={t("NO")}
          showCancel
        >
          {t("Sei sicuro?")}
        </SweetAlert>
      )
    });
  }





  async deleteProfile() {
    let { selectedProfile, handleDeletedProfile, t } = this.props;
    try {

      let res = await loopbackService.list("plant", "timerprofileweekly", {
        or: [
          { monFriProfileId: selectedProfile.id },
          { satProfileId: selectedProfile.id },
          { sunProfileId: selectedProfile.id }
        ]
      });

      if (res.length > 0) {

        this.setState({
          alert: (
            <SweetAlert
              warning
              customClass="custom-sweet-alert"
              style={{ display: "block" }}
              title={t("Impossibile eliminare il profilo")}
              onConfirm={() => {
                this.setState({
                  alert: null
                });
              }}
              confirmBtnBsStyle="info"
              confirmBtnText={t("OK")}
            >
              {t("Viene utilizzato nel profilo settimanale: ") + res[0].label}
            </SweetAlert>
          )
        });

        return;
      }

      await loopbackService.delete("plant", "timerprofiledaily", selectedProfile.id);
      handleDeletedProfile();
    } catch (error) {
      this.setState({
        errors: [error]
      })
    }
  }




}

export default DailyProfile = withTranslation()(DailyProfile);


// WEBPACK FOOTER //
// ./src/views/TimerProfiles/DailyProfile.jsx